import { SxProps, Theme } from '@mui/material';

export const voiceVisualizerContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1px',
  width: '100%',
  height: '36.5px',
  margin: '0 !important',
  padding: '4px 8px',
  background: "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
  borderRadius: '12px',
  boxShadow: `0 4px 15px ${theme.palette.flashColors.flash1}30`,
  overflow: 'hidden',
  position: 'relative',
  flexShrink: 0,
});


export const voiceBarStyles = (height: number, isPlaying: boolean): SxProps<Theme> => ({
  width: '3px',
  height: `${Math.min(height * 100, 100)}%`,
  backgroundColor: 'white',
  borderRadius: '2px',
  transition: isPlaying ? 'none' : 'height 0.1s ease-out',
  minHeight: '1px',
  maxHeight: '28px !important',
  flexShrink: 0,
  alignSelf: 'flex-end',
});
